import Page from '@pelckmans/elementis/components/page';
import Tabs from '@pelckmans/elementis/components/tabs';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ApplicationLevelLayout from '../../layout/ApplicationLevelLayout';
import ContentHeader from '../../layout/content/ContentHeader';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import ContentBody from '../../layout/content/ContentBody';
import {
  withScrollThreshold,
  WithScrollThresholdProps,
} from '../../shared-components/elementis/hoc/withScrollThreshold';
import { useRoutes } from '../../hooks/useRoutes';

export const TABS = {
  MY_DETAILS: 'MY_DETAILS',
  LICENSES: 'LICENSES',
};

interface MyProfileProps extends WithScrollThresholdProps {}

function MyProfile({ pastThreshold }: MyProfileProps) {
  const { t } = useTranslation();

  useDocumentTitle(t('PAGES.PROFILE.DOCUMENT_TITLE'));

  const { getRoute } = useRoutes();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTab = location.pathname.includes(getRoute('MY_PROFILE.LICENSES')) ? TABS.LICENSES : TABS.MY_DETAILS;

  const onTabChange = useCallback(
    (tab: string) => {
      if (tab === selectedTab) return;

      const route = tab === TABS.LICENSES ? getRoute('MY_PROFILE.LICENSES') : getRoute('MY_PROFILE.PERSONAL_DETAILS');

      navigate(route);
    },
    [getRoute, navigate, selectedTab],
  );

  return (
    <ApplicationLevelLayout>
      <Tabs selectedTab={selectedTab} onTabChange={onTabChange}>
        <ContentHeader
          cover={
            <Page.Header
              density={pastThreshold ? 'compact' : 'normal'}
              headerText={t('PAGES.PROFILE.HEADER.TITLE')}
              tabs={
                <Tabs.TabList aria-label={t('PAGES.PROFILE.HEADER.TAB_LIST.A11Y_LABEL')}>
                  <Tabs.Tab id={TABS.MY_DETAILS}>{t('PAGES.PROFILE.HEADER.TAB_LIST.TABS.MY_DETAILS')}</Tabs.Tab>
                  <Tabs.Tab id={TABS.LICENSES}>{t('PAGES.PROFILE.HEADER.TAB_LIST.TABS.LICENSES')}</Tabs.Tab>
                </Tabs.TabList>
              }
            />
          }
        />
        <ContentBody>
          <div className="my-profile">
            <Outlet />
          </div>
        </ContentBody>
      </Tabs>
    </ApplicationLevelLayout>
  );
}

export default withScrollThreshold(MyProfile);
